import callout from './common/callout';
import map from './common/map';
import map3d from './common/map3d';
import robot from './common/robot';
import robots from './common/robots';
import robotStatus from './common/robotStatus';
import telemetry from './common/telemetry';
import user from './common/user';
import command from './control-center/command';
import missionsForControlCenter from './control-center/missions';
import notifications from './control-center/notifications';
import robotOptions from './control-center/robotOptions';
import robotParams from './control-center/robotParams';
import query from './flight-review/query';
import editor from './mission-hub/editor';
import mission from './mission-hub/mission';
import missionsForMissionHub from './mission-hub/missions';
import videos from './video-manager/videos';

const actions = {};

export const setActionsForPage = (pageType) => {
  switch (pageType) {
    case 'control-center':
      actions.callout = callout;
      actions.command = command;
      actions.map = map;
      actions.map3d = map3d;
      actions.missions = missionsForControlCenter;
      actions.notifications = notifications;
      actions.robot = robot;
      actions.robots = robots;
      actions.robotStatus = robotStatus;
      actions.robotOptions = robotOptions;
      actions.robotParams = robotParams;
      actions.telemetry = telemetry;
      actions.user = user;
      break;

    case 'mission-hub':
      actions.callout = callout;
      actions.editor = editor;
      actions.map = map;
      actions.map3d = map3d;
      actions.mission = mission;
      actions.missions = missionsForMissionHub;
      actions.robots = robots;
      actions.robotStatus = robotStatus;
      actions.telemetry = telemetry;
      actions.user = user;
      break;

    case 'mobile':
      actions.map = map;
      actions.robot = robot;
      actions.robots = robots;
      actions.telemetry = telemetry;
      actions.user = user;
      break;

    case 'video-manager':
      actions.robot = robot;
      actions.robots = robots;
      actions.user = user;
      actions.videos = videos;
      break;

    case 'flight-review':
      actions.robots = robots;
      actions.user = user;
      actions.query = query;
      break;

    default:
      break;
  }
};

export default actions;
